<template>
    <div>
        <Card>
            <p slot="title"> ERP Journal Pooling (Log) </p>

            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="6">
                    <ButtonGroup class="custom-group-parent">
                        <Button class="custom-group">Status</Button>
                        <Select
                            v-model="filterStatus"
                            clearable
                            @on-change="getERPJournalPooling">
                            <Option v-for="status, idx in dataStatuses" :value="status.type" :key="idx">
                                {{ status.name }}
                            </Option>
                        </Select>
                    </ButtonGroup>
                </Col>

                <Col span="17">
                    <Spin size="large" v-show="isLoadingSearch"></Spin>
                </Col>
            </Row>

            <br>

            <Card>
                <Table :columns="tableColumns" :data="dataPooling"></Table>
            </Card>
        </Card>
    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'

export default {
    data () {
        return {
            filterStatus : '',
            dataStatuses : [
                {
                    type : 'all',
                    name : 'ALL'
                },
                {
                    type : 'success',
                    name : 'SUCCESS'
                },
                {
                    type : 'error',
                    name : 'ERROR'
                },
                {
                    type : 'sent',
                    name : 'SENT'
                },
            ],
            isLoadingSearch : false,

            tableColumns: [
                {
                    title: 'Created Date',
                    key: 'arrivalcreateddtm'
                },
                {
                    title: 'Status',
                    key: 'is_sent'
                },
                {
                    title: 'Marking',
                    key: 'markingheadercode'
                },
                {
                    title: 'Cont. Number | Partai',
                    key: 'cNumberCCode'
                },
                {
                    title: 'Index Number',
                    key: 'noresi'
                },
                {
                    title: 'Response Status',
                    key: 'is_success'
                },
            ],
            dataPooling : []
        }
    },
    methods: {
      getERPJournalPooling: function(){
          this.dataPooling = [];
          this.isLoadingSearch = true;

          console.log(this.filterStatus);

          return false

          HTTP.get('claim/search/' + this.filterStatus)
          .then(response => {
              console.log({response});

              this.isLoadingSearch = false;
          })
          .catch(e => {
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          });
      },
    },
}

</script>



// WEBPACK FOOTER //
// ERPJournalPooling.vue?8ca0a26e